import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const paymentsSave: TypedDocumentNode<Pick<GQL.IMutation, "paymentsSave">, GQL.IMutationPaymentsSaveArgs> = gql`
    mutation paymentsSave($input: PaymentsSaveInput!) {
        paymentsSave(input: $input) {
            status
            summary {
                productId
                action
                id
            }
        }
    }
`;

// FIBU-407: dry run - returns the prospective execution summary + the journaled/confirmed approval
// verdict WITHOUT committing. The FE renders the confirmation from this, then commits via paymentsSave.
export const paymentsSavePreflight: TypedDocumentNode<
    Pick<GQL.IMutation, "paymentsSavePreflight">,
    GQL.IMutationPaymentsSavePreflightArgs
> = gql`
    mutation paymentsSavePreflight($input: PaymentSavePreflightInput!) {
        paymentsSavePreflight(input: $input) {
            summary {
                productId
                action
                id
            }
            requiresApproval {
                journaled
                confirmed
            }
        }
    }
`;

// B3: manual linking on the server; a change that needs approval writes nothing and answers requiresApproval.
export const paymentConnect: TypedDocumentNode<
    Pick<GQL.IMutation, "paymentConnect">,
    GQL.IMutationPaymentConnectArgs
> = gql`
    mutation paymentConnect(
        $companyId: ID!
        $representationKey: ID!
        $sourceKey: ID!
        $discountAmount: Int53
        $approvals: PaymentApprovalsInput
    ) {
        paymentConnect(
            companyId: $companyId
            representationKey: $representationKey
            sourceKey: $sourceKey
            discountAmount: $discountAmount
            approvals: $approvals
        ) {
            status
            summary {
                productId
                action
                id
            }
            requiresApproval {
                journaled
                confirmed
            }
        }
    }
`;

export const paymentDisconnect: TypedDocumentNode<
    Pick<GQL.IMutation, "paymentDisconnect">,
    GQL.IMutationPaymentDisconnectArgs
> = gql`
    mutation paymentDisconnect($companyId: ID!, $representationKey: ID!, $approvals: PaymentApprovalsInput) {
        paymentDisconnect(companyId: $companyId, representationKey: $representationKey, approvals: $approvals) {
            status
            summary {
                productId
                action
                id
            }
            requiresApproval {
                journaled
                confirmed
            }
        }
    }
`;

export const paymentSplit: TypedDocumentNode<Pick<GQL.IMutation, "paymentSplit">, GQL.IMutationPaymentSplitArgs> = gql`
    mutation paymentSplit(
        $companyId: ID!
        $recordKey: ID!
        $parts: [PaymentSplitPartInput!]!
        $approvals: PaymentApprovalsInput
    ) {
        paymentSplit(companyId: $companyId, recordKey: $recordKey, parts: $parts, approvals: $approvals) {
            status
            summary {
                productId
                action
                id
            }
            requiresApproval {
                journaled
                confirmed
            }
        }
    }
`;
